"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _dataAids = _interopRequireDefault(require("../../constants/dataAids"));

var _ellipseString = _interopRequireDefault(require("../../utils/ellipseString"));

var _ExpandCta = _interopRequireDefault(require("./ExpandCta"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var states = {
  INITIAL: 'INITIAL',
  TRUNCATED: 'TRUNCATED',
  EXPANDED: 'EXPANDED'
};

var Truncate = /*#__PURE__*/function (_PureComponent) {
  _inherits(Truncate, _PureComponent);

  var _super = _createSuper(Truncate);

  function Truncate() {
    var _this;

    _classCallCheck(this, Truncate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      displayState: states.INITIAL
    });

    _defineProperty(_assertThisInitialized(_this), "textNode", (0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "handleClickMore", function (event) {
      event.stopPropagation();
      var _this$props = _this.props,
          onClickMore = _this$props.onClickMore,
          isCollapsible = _this$props.isCollapsible;
      var displayState = _this.state.displayState;

      if (onClickMore) {
        onClickMore();
      }

      if (isCollapsible && displayState === states.EXPANDED) {
        _this.setState({
          displayState: states.TRUNCATED
        });

        return;
      }

      _this.setState({
        displayState: states.EXPANDED
      });
    });

    return _this;
  }

  _createClass(Truncate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleTruncation();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.isInitial()) {
        this.handleTruncation();
      }
    }
  }, {
    key: "handleTruncation",
    value: function handleTruncation() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          maxEllipseCharacters = _this$props2.maxEllipseCharacters,
          children = _this$props2.children;
      var textNode = this.textNode.current;

      if (width === null && maxEllipseCharacters === null) {
        return;
      }

      if (textNode.offsetWidth > width || children.length > maxEllipseCharacters) {
        this.setState({
          displayState: states.TRUNCATED
        });
      } else {
        this.setState({
          displayState: states.EXPANDED
        });
      }
    }
  }, {
    key: "isInitial",
    value: function isInitial() {
      return this.state.displayState === states.INITIAL;
    }
  }, {
    key: "isTruncated",
    value: function isTruncated() {
      return this.state.displayState === states.TRUNCATED;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          maxEllipseCharacters = _this$props3.maxEllipseCharacters;

      if (maxEllipseCharacters && children.length > maxEllipseCharacters && this.isTruncated()) {
        return (0, _ellipseString["default"])(children, maxEllipseCharacters);
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          i18n = _this$props4.i18n,
          isCollapsible = _this$props4.isCollapsible,
          style = _this$props4.style,
          _this$props4$expandCt = _this$props4.expandCtaAs,
          T = _this$props4$expandCt === void 0 ? _guacWidgetCore.UX2.Element.Link : _this$props4$expandCt,
          children = _this$props4.children,
          maxEllipseCharacters = _this$props4.maxEllipseCharacters,
          onExpandCtaMount = _this$props4.onExpandCtaMount;
      var displayState = this.state.displayState;
      var expanded = isCollapsible && displayState === states.EXPANDED;
      return /*#__PURE__*/_react["default"].createElement(_guacWidgetCore.UX2.Element.Element, {
        style: style.container
      }, /*#__PURE__*/_react["default"].createElement("span", {
        ref: this.textNode,
        style: style[displayState.toLocaleLowerCase()],
        "data-aid": _dataAids["default"].TRUNCATE_DESCRIPTION
      }, this.renderChildren()), (this.isTruncated() || children.length > maxEllipseCharacters && isCollapsible) && /*#__PURE__*/_react["default"].createElement(T, {
        expanded: expanded,
        tag: "span",
        style: style.moreLink,
        onClick: this.handleClickMore,
        "data-aid": _dataAids["default"].TRUNCATE_MORE_LINK
      }, expanded ? i18n.collapseCta : /*#__PURE__*/_react["default"].createElement(_ExpandCta["default"], {
        i18n: i18n,
        onMount: onExpandCtaMount
      })));
    }
  }]);

  return Truncate;
}(_react.PureComponent);

_defineProperty(Truncate, "propTypes", {
  width: _propTypes["default"].number,
  i18n: _propTypes["default"].shape({
    expandCta: _propTypes["default"].string.isRequired,
    collapseCta: _propTypes["default"].string
  }).isRequired,
  onClickMore: _propTypes["default"].func,
  onExpandCtaMount: _propTypes["default"].func,
  children: _propTypes["default"].string,
  style: _propTypes["default"].object,
  expandCtaAs: _propTypes["default"].any,
  maxEllipseCharacters: _propTypes["default"].number,
  isCollapsible: _propTypes["default"].bool
});

_defineProperty(Truncate, "defaultProps", {
  style: {
    container: {
      display: 'flex',
      maxWidth: '100%'
    },
    initial: {
      whiteSpace: 'nowrap'
    },
    truncated: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    expanded: {
      whiteSpace: 'initial',
      overflow: 'initial',
      textOverflow: 'initial',
      minWidth: 0
    },
    moreLink: {
      flexShrink: 0,
      cursor: 'pointer'
    }
  }
});

var _default = Truncate;
exports["default"] = _default;